export enum SkillKind {
  CAPABILITY = "capability",
  PLAYBOOK = "playbook",
}

export enum SkillStatus {
  DRAFT = "draft",
  ACTIVE = "active",
  ARCHIVED = "archived",
}

export enum TemplateType {
  MARKDOWN = "markdown",
  HTML = "html",
  JSON = "json",
  CSV = "csv",
  EMAIL = "email",
  SLACK = "slack",
}

export type SkillTemplate = {
  id?: string;
  template_name: string;
  template_type: string;
  template_content: string;
  is_default?: boolean;
};

export type SkillInstruction = {
  id?: string;
  instructions_markdown: string;
  version: number;
  version_tag?: string;
  is_active: boolean;
  status: string;
  created_at?: string;
  change_summary?: string;
};

export type SkillConfiguration = {
  id?: string;
  config_data: {
    triggers?: {
      keywords?: string[];
    };
    [key: string]: any;
  };
};

export type CustomSkill = {
  id: string;
  workspace_id: string;
  skill_name: string;
  display_name: string;
  description: string;
  kind: string;
  status: string;
  version: string;
  priority: number;
  is_enabled: boolean;
  visibility?: "workspace" | "private" | "protected";
  output_format?: string | null;
  output_format_type?: "none" | "json_schema" | "markdown_template";
  instructions?: SkillInstruction;
  configuration?: SkillConfiguration;
  templates?: SkillTemplate[];
  created_at: string;
  updated_at: string;
};

export type CreateSkillPayload = {
  workspace_id: string;
  name: string;
  display_name: string;
  description: string;
  kind: SkillKind;
  instructions_content: string;
  priority?: number;
  keywords?: string[];
  templates?: {
    template_name: string;
    template_type: string;
    template_content: string;
    is_default?: boolean;
  }[];
  output_format?: string;
  output_format_type?: "none" | "json_schema" | "markdown_template";
  visibility?: "workspace" | "private" | "protected";
};

export type UpdateSkillPayload = {
  workspace_id: string;
  skill_id: string;
  name?: string;
  display_name?: string;
  description?: string;
  kind?: SkillKind;
  instructions_content?: string;
  priority?: number;
  keywords?: string[];
  templates?: {
    template_name: string;
    template_type: string;
    template_content: string;
    is_default?: boolean;
  }[];
  status?: SkillStatus;
  enabled?: boolean;
  output_format?: string;
  output_format_type?: "none" | "json_schema" | "markdown_template";
  visibility?: "workspace" | "private" | "protected";
};

export type SkillVersionSummary = {
  id: string;
  version: number;
  version_tag?: string;
  is_active: boolean;
  status: string;
  created_at: string;
  change_summary?: string;
  content_preview?: string;
};

export type GenerateSkillContentPayload = {
  workspace_id: string;
  prompt: string;
  existing_content?: string;
};

export type GenerateSkillContentResponse = {
  content: string;
};
